<template>
  <div>
    <DsPageTransition :name="transition">
      <component value
                 :is="component"></component>
    </DsPageTransition>
    <BaseLoader></BaseLoader>
  </div>
</template>

<script>
import BaseLoader from '@/components/ui/BaseLoader/BaseLoader'
import { getDeviceType } from '@/helpers/getDeviceType'
import {
  DsLayout,
  DsPageTransition,
  DsNavBar,
  DsNavButton,
  DsIcon
} from "@ds/vue2"
import useStore from '@/composables/useStore'
import start from '@/components/pages/landing/container'
import { KASPI } from '@/config'
import AndRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AndRuleSpecification'
import IsMobileApp from '@/rules/IsMobileApp'
import IsAvailableIsAuthorized from '@/rules/IsAvailableIsAuthorized'
import otp from '@/components/Otp/Otp.vue'
import reject from '@/components/pages/reject/reject'
import KidsList from '@/components/pages/kid-list/kid-list'
import NoKidFound from '@/components/pages/no-kid-found/no-kid-found'
import Debts from '@/components/pages/debts/debts'
import Typ from '@/components/pages/go-to-cardomat/go-to-cardomat.vue'
import enterPhone from '@/components/pages/enter-phone/enter-phone.vue'
import GoldkidAgreement from "@/components/pages/goldkid-agreement/goldkid-agreement.vue"
import MainAgreement from '@/components/pages/main-agreement/main-agreement.vue'
import Unavailable from '@/components/pages/unavailable/unavailable.vue'
import NewYearUnavailable from '@/components/pages/new-year-unavailable/new-year-unavailable.vue'
import { computed, onMounted } from 'vue'
import useHeader from '@/composables/useHeader'
import translate from '@/filters/translate.filter'
import Error from '@/components/pages/error/error.vue'
export default {
  components: {
    otp,
    reject,
    KidsList,
    NoKidFound,
    Debts,
    Typ,
    enterPhone,
    Unavailable,
    NewYearUnavailable,
    start,
    MainAgreement,
    GoldkidAgreement,
    BaseLoader,
    DsLayout,
    DsNavBar,
    DsNavButton,
    DsIcon,
    DsPageTransition,
    Error
  },
  computed: {
    component() {
      return this.$store.getters['goldkidProcess/component']
    }
  },
  watch: {
    component(newVal, oldVal) {
      if (newVal !== oldVal) {
        window.scrollTo(0, 0)
      }
      this.$nextTick(() => {
        this.setTransition('slide-left')
      }
      )
    }
  },
  setup() {
    const store = useStore()

    const { backFn, backBtnIsShown, title, setTitle, setBackFn, defaultBackNavigationFunction, transition, setTransition } = useHeader()
    setTitle(translate('title:goldkid'))
    setBackFn(() => {
      defaultBackNavigationFunction()
    })

    const isIos = computed(() => {
      return getDeviceType() === 'ios'
    })
    onMounted(() => {
      store.dispatch('goldkidProcess/getSettings')
      if ((new AndRuleSpecification(new IsMobileApp(), new IsAvailableIsAuthorized())).isSatisfiedBy(KASPI.mobapp)) {
        KASPI.mobapp.isAuthorized(KASPI.authCallbacks.isAuthorized)
      } else {
        authenticate()
      }
    })

    const isAuthenticated = function () {
      return store.getters['auth/isAuthenticated']
    }
    const authenticate = function () {
      store.dispatch('auth/authenticate')
        .catch(() => {
          //
        })
    }

    return {
      authenticate,
      isAuthenticated,
      isIos,
      backFn,
      title,
      backBtnIsShown,
      getDeviceType,
      transition,
      setTransition,
    }
  }
}
</script>
